import { TimePicker } from '@mui/x-date-pickers';
import { useStore } from '@tanstack/react-form';
import moment from 'moment';
import { useFieldContext } from '.';

type TimeFieldProps = {
  label: React.ReactNode;
  /** Display format for the picker (e.g. 'HH:mm'). Defaults to 'HH:mm'. */
  format?: string;
  /** Format used for parsing and serializing the string value. Defaults to 'HH:mm'. */
  valueFormat?: string;
  disableFuture?: boolean;
};

export const TimeField = (props: TimeFieldProps) => {
  const field = useFieldContext<string | null | undefined>();
  const hasTriedToSubmit = useStore(
    field.form.store,
    (state) => state.submissionAttempts > 0
  );

  const valFmt = props.valueFormat || 'HH:mm';

  const timeValue = field.state.value
    ? moment(field.state.value, valFmt)
    : null;

  return (
    <TimePicker
      label={props.label}
      value={timeValue}
      format={props.format || 'HH:mm'}
      onChange={(momentDate) => {
        if (!momentDate || !momentDate.isValid()) {
          return field.handleChange(null);
        }
        return field.handleChange(momentDate.format(valFmt) || null);
      }}
      onClose={field.handleBlur}
      disableFuture={props.disableFuture}
      slotProps={{
        textField: {
          fullWidth: true,
          error:
            field.state.meta.isTouched || hasTriedToSubmit
              ? field.state.meta.errors.length > 0
              : false,
          helperText:
            field.state.meta.isTouched || hasTriedToSubmit
              ? field.state.meta.errors
                  .map((error) => error?.message ?? '')
                  .filter(Boolean)
                  .join(', ') || undefined
              : undefined,
        },
      }}
    />
  );
};
